module.exports = function() {
  return new Worker(__webpack_public_path__ + "1f28762560442f7121b4.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./~/pdfjs-dist/es5/build/pdf.worker.js
// module id = 1111
// module chunks = 0